import type { Advisory, VersionsBereich } from './types'

function bereich(b: VersionsBereich): string {
  if (!b.bis) return `ab ${b.von}`
  const bis = b.bis_einschliesslich ? `bis ${b.bis}` : `bis unter ${b.bis}`
  if (!b.von) return bis
  if (b.von === b.bis && b.bis_einschliesslich) return b.von
  return `${b.von} ${bis}`
}

/** Welche Versionen ein Hinweis betrifft, in Worten. */
export function betroffeneVersionen(a: Advisory): string {
  if (a.quelle === 'kev') {
    const bereiche = a.bereiche ?? []
    return bereiche.length === 0 ? 'Versionen nicht angegeben' : bereiche.map(bereich).join(', ')
  }
  const ab = a.betrifft_ab ? `ab ${a.betrifft_ab}` : 'alle Versionen'
  return a.behoben_in ? `${ab}, behoben in ${a.behoben_in}` : ab
}
